import { LitEntity, html, css } from '../../utility/lit-entity';
import { BinIssueStateMixin } from './bin-issue-state-mixin';

class BinIssueStatePhysicalIssueQuestion extends BinIssueStateMixin(LitEntity) {
  static get styles() {
    return [...super.styles, css`
      h2 {
        margin: 2em;
      }
    `];
  }

  render() {
    return html`
      <h2>Is the device on this bin physically damaged in any way?</h2>
      ${this.renderYesNo()}
    `;
  }
}

window.customElements.define('bin-issue-state-physical-issue-question', BinIssueStatePhysicalIssueQuestion);
